module.exports = __webpack_public_path__ + "static/img/twoyear.3cfd8cfa.png";